//@author devin
import { DataAccess } from "../dataaccess/data.access";
import { S25Util } from "./s25-util";
import { S25Const } from "./s25-const";
import { MasterDefinitionService, MasterDefType } from "../services/master.definitions/master.definition.service";
import { CustomAttributes } from "../pojo/CustomAttributes";
import { Usage } from "../standalone/s25.usage.component";

export class MasterDefinitionUtil {
    public static get(serviceUrl: string, rootNodeName: string, itemNodeName: string) {
        return DataAccess.get(serviceUrl).then(function (data) {
            return (
                (data &&
                    data[rootNodeName] &&
                    data[rootNodeName][itemNodeName] &&
                    S25Util.array.forceArray(data[rootNodeName][itemNodeName])) ||
                []
            ).map((item: any) => {
                item.attribute_type_name = S25Const.custAtrbType2Name[item.attribute_type] || item.attribute_type_name;
                return item;
            });
        });
    }

    public static getSpecific(
        serviceUrl: string,
        rootNodeName: string,
        itemNodeName: string,
        idNodeName: string,
        itemId: number,
    ) {
        serviceUrl = S25Util.addParam(serviceUrl, idNodeName, itemId);
        return MasterDefinitionUtil.get(serviceUrl, rootNodeName, itemNodeName).then(function (data) {
            return data && data.length && data[0];
        });
    }

    public static delete(serviceUrl: string, idNodeName: string, itemId: number) {
        serviceUrl = S25Util.addParam(serviceUrl, idNodeName, itemId);
        return DataAccess.delete(serviceUrl);
    }

    public static forceDelete(serviceUrl: string, idNodeName: string, itemId: number) {
        let type: string = "";
        let itemTypeId: number = 0;

        if (idNodeName.indexOf("attr") > -1) {
            type = "custom_attribute";
            if (serviceUrl.indexOf("ev") > -1) {
                itemTypeId = 1;
            } else if (serviceUrl.indexOf("rm") > -1) {
                itemTypeId = 4;
            } else if (serviceUrl.indexOf("res") > -1) {
                itemTypeId = 6;
            } else if (serviceUrl.indexOf("org") > -1) {
                itemTypeId = 2;
            } else {
                //con
                itemTypeId = 3;
            }
        } else if (idNodeName.indexOf("category") > -1) {
            type = "category";
            if (serviceUrl.indexOf("ev") > -1) {
                itemTypeId = 1;
            } else if (serviceUrl.indexOf("rm") > -1) {
                itemTypeId = 4;
            } else if (serviceUrl.indexOf("rs") > -1) {
                itemTypeId = 6;
            } else {
                //org
                itemTypeId = 2;
            }
        } else if (idNodeName.indexOf("requirement") > -1) {
            type = "requirement";
            itemTypeId = 1;
        } else if (idNodeName.indexOf("role") > -1) {
            if (serviceUrl.indexOf("ev") > -1) {
                type = "event_contact_role";
                itemTypeId = 1;
            } else {
                //org
                type = "organization_contact_role";
                itemTypeId = 2;
            }
        } else if (serviceUrl.indexOf("org") > -1 && idNodeName.indexOf("type") > -1) {
            type = "organization_types";
            itemTypeId = 2;
        } else if (serviceUrl.indexOf("ev") > -1 && idNodeName.indexOf("type") > -1) {
            type = "event_types";
            itemTypeId = 1;
        } else if (idNodeName.indexOf("rating") > -1) {
            type = "organization_ratings";
            itemTypeId = 2;
        } else if (idNodeName.indexOf("layout") > -1) {
            type = "location_layouts";
            itemTypeId = 4;
        } else if (idNodeName.indexOf("partition") > -1) {
            type = "location_partitions";
            itemTypeId = 4;
        } else if (idNodeName.indexOf("feature") > -1) {
            type = "location_features";
            itemTypeId = 4;
        }

        return DataAccess.delete(
            "/master/definition.json?itemId=" + itemId + "&itemTypeId=" + itemTypeId + "&type_name=" + type,
        );
    }

    public static setterBulk(
        serviceUrl: string,
        rootNodeName: string,
        itemNodeName: string,
        idNodeName: string,
        itemIds: number[],
        status: string,
        payload: any,
    ) {
        itemIds = S25Util.array.forceArray(itemIds);
        if (itemIds.length <= 1)
            return MasterDefinitionUtil.setter(
                serviceUrl,
                rootNodeName,
                itemNodeName,
                idNodeName,
                itemIds[0],
                status,
                payload,
            );
        return MasterDefinitionUtil.get(serviceUrl, rootNodeName, itemNodeName).then(function (data) {
            if (data && data.length) {
                let items = data.filter((item: any) => itemIds.indexOf(item[idNodeName]) > -1);
                if (items && items.length) {
                    items.forEach((item: any) => {
                        if (payload) {
                            item.status = status;
                            Object.assign(item, payload);
                        }
                    });

                    //the master definition PUTs do not support bulk updates but posts do.
                    return DataAccess.post(serviceUrl, {
                        [rootNodeName]: {
                            [itemNodeName]: items,
                        },
                    });
                }
            }
        });
    }

    public static setter(
        serviceUrl: string,
        rootNodeName: string,
        itemNodeName: string,
        idNodeName: string,
        itemId: number,
        status: string,
        payload: any,
    ) {
        return MasterDefinitionUtil.getSpecific(serviceUrl, rootNodeName, itemNodeName, idNodeName, itemId).then(
            function (item) {
                if (item) {
                    if (payload) {
                        Object.assign(item, payload);
                        serviceUrl = S25Util.addParam(serviceUrl, idNodeName, itemId);
                        return DataAccess.put(
                            serviceUrl,
                            S25Util.getPayload(rootNodeName, itemNodeName, idNodeName, status, itemId, item),
                        );
                    }
                }
            },
        );
    }

    public static setName(
        serviceUrl: string,
        rootNodeName: string,
        itemNodeName: string,
        idNodeName: string,
        nameNodeName: string,
        itemId: number,
        itemName: string,
    ) {
        let payload: any = {};
        payload[nameNodeName] = itemName;
        return MasterDefinitionUtil.setter(serviceUrl, rootNodeName, itemNodeName, idNodeName, itemId, "mod", payload);
    }

    public static setActive(
        serviceUrl: string,
        rootNodeName: string,
        itemNodeName: string,
        idNodeName: string,
        itemIds: number[],
        active: boolean,
    ) {
        let activeStr: string = active ? "1" : "0";
        return MasterDefinitionUtil.setterBulk(serviceUrl, rootNodeName, itemNodeName, idNodeName, itemIds, "mod", {
            defn_state: activeStr,
        });
    }

    public static setValue(
        serviceUrl: string,
        rootNodeName: string,
        itemNodeName: string,
        idNodeName: string,
        valueNodeName: string,
        itemIds: number | number[],
        value: any,
    ) {
        let payload: any = {};
        payload[valueNodeName] = value;
        return MasterDefinitionUtil.setterBulk(
            serviceUrl,
            rootNodeName,
            itemNodeName,
            idNodeName,
            S25Util.array.forceArray(itemIds),
            "mod",
            payload,
        );
    }

    public static setValues(
        serviceUrl: string,
        rootNodeName: string,
        itemNodeName: string,
        idNodeName: string,
        itemId: number | number[],
        paramMap: any,
    ) {
        return MasterDefinitionUtil.setterBulk(
            serviceUrl,
            rootNodeName,
            itemNodeName,
            idNodeName,
            S25Util.array.forceArray(itemId),
            "mod",
            paramMap,
        );
    }

    public static getNewId(serviceUrl: string, idNodeName: string) {
        return DataAccess.post(serviceUrl).then(function (data) {
            return parseInt(S25Util.propertyGet(data, idNodeName));
        });
    }

    public static createNew(
        serviceUrl: string,
        rootNodeName: string,
        itemNodeName: string,
        idNodeName: string,
        nameNodeName: string,
        paramMap?: any,
    ) {
        return MasterDefinitionUtil.getNewId(serviceUrl, idNodeName).then(function (itemId) {
            let itemName = "New_" + itemId;
            let payload: any = paramMap || {};
            payload[nameNodeName] = itemName;
            return DataAccess.post(
                serviceUrl,
                S25Util.getPayload(rootNodeName, itemNodeName, idNodeName, "new", itemId, payload),
            ).then(function () {
                let ret: any = payload || {};
                ret[idNodeName] = itemId;
                ret[nameNodeName] = itemName;
                ret.defn_state = 1;

                return ret;
            });
        });
    }

    //Trumba needs a URL format for "Event Image", "Detail Image" and "Web Site"
    //more info here below:
    //https://knowledge25.knowledgeowl.com/help/preparing-25live-for-optimal-use-with-publisher-data-preparation
    //https://collegenet.atlassian.net/wiki/spaces/SPECS/pages/18186707/Legacy+System+Defined+Master+Definitions
    public static isUrl(
        type: CustomAttributes.UrlAttributeType,
        attribute_type: string,
        attribute_id: number,
    ): boolean {
        if (attribute_type !== "R") return false;
        const urlIds = CustomAttributes.system.urlAttributeIds[type];
        return urlIds?.includes(attribute_id) ?? false;
    }

    public static async usageService(masterListType: string, masterListId: number): Promise<Usage> {
        const usage = await MasterDefinitionService.getUsage(masterListType, masterListId);
        return {
            name: usage.master_name,
            types: [
                {
                    type: "Object Usage",
                    uses: usage.object.map((use) => ({ name: use.object_name })),
                    noUsesMessage: "No objects use this master definition",
                },
                {
                    type: "Search Usage",
                    uses: usage.search.map((use) => ({ name: use.search_name })),
                    noUsesMessage: "No searches use this master definition",
                },
            ],
        };
    }
}
